import React from 'react';
import PropTypes from 'prop-types';
import IconBuildings from '@spothero/icons/buildings';
import {Box, Heading, Icon, Text} from '@spothero/ui';

const FacilityListEmpty = ({heading, body}) => {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            margin={4}
        >
            <Box
                borderRadius="100%"
                padding={6}
                backgroundColor="gray.light"
                marginBottom={4}
            >
                <Box textAlign="center" height={20} width={20}>
                    <Icon as={IconBuildings} boxSize={12} />
                    <Text
                        variant="caption"
                        fontWeight="semibold"
                        borderRadius={5}
                        paddingX={2}
                        color="error"
                        backgroundColor="white"
                    >
                        0 Results
                    </Text>
                </Box>
            </Box>
            <Heading as="h5" marginBottom={2}>
                {heading}
            </Heading>
            <Text variant="body2">{body}</Text>
        </Box>
    );
};

FacilityListEmpty.propTypes = {
    heading: PropTypes.string,
    body: PropTypes.string,
};

export default FacilityListEmpty;
